import ModalPopup from 'components/ModalPopup/ModalPopup'
import { ModalPopupSize } from 'lib/enums'
import Select from 'components/FormComponents/Select/Select'
import { BulkApplyInitialization } from './BulkApplyModalInitialization'
import './bulkApplyModal.scss'
import { BulkApplyData, SiteDesignGetPayload } from '../../../lib/types'

const BulkApplyModal = ({isModalDisplayed, displayModal, siteDesignPayload, applyBulkSettings }: BulkApplyModalProps) => {
    const {
        isBulkApplyModalDisplayed,
        applyBulkSetting,
        bulkApplyOptions,
        handleBulkApplySelector,
        bulkApplyElements,
        selectedBulkApplyColumn,
        setBulkApplyValue,
        getDefaultPropertyValue
    } = BulkApplyInitialization(isModalDisplayed, displayModal, siteDesignPayload, applyBulkSettings)

    return (
        <ModalPopup
            size={ModalPopupSize.Small}
            showModal={isBulkApplyModalDisplayed}
            onCloseButtonclick={() => displayModal(false)}
            button1Label="Apply"
            headline="Bulk apply setting"
            description="Choose the setting you want to edit and choose a value for it. This value will be applied to all your created camera groups."
            button1OnClickHandler={applyBulkSetting}>
            <div className="my-8">
                <Select className="xsd-bulk-apply-select pb-4" options={bulkApplyOptions} handleDataChange={handleBulkApplySelector} />
                {bulkApplyElements[selectedBulkApplyColumn](setBulkApplyValue, getDefaultPropertyValue(selectedBulkApplyColumn))}
            </div>
        </ModalPopup>
    )
}

type BulkApplyModalProps = {    
    isModalDisplayed: boolean,
    displayModal: (state: boolean) => void,
    siteDesignPayload: SiteDesignGetPayload,
    applyBulkSettings: (bulkApplyData: BulkApplyData) => void
}

export default BulkApplyModal
